import React from "react";
import AppBar from "material-ui/AppBar";
import Drawer from "material-ui/Drawer";
import MenuItem from "material-ui/MenuItem";
import { connectWithLifecycle } from "react-lifecycle-component";
import IconButton from "material-ui/IconButton";
import NavigationMenu from "material-ui/svg-icons/navigation/menu";
import { push } from "react-router-redux";

import { showMainMenu } from "../../redux/modules/uiDuck";
import { getShowMainMenuMap } from "../../redux/selectors";
import { subscribeOrdersRequest } from "../../redux/modules/ordersDuck";
import { fetchInitialDataRequest } from "../../redux/rootRedux";
import OnlineBanner from "../OnlineBanner";

const mapStateToProps = state => {
  return {
    showMenu: getShowMainMenuMap(state)
  };
};

const mapDispatchToProps = dispatch => ({
  handleSwitchMainMenu: value => {
    dispatch(showMainMenu(value));
  },
  handleProducersPage: value => {
    dispatch(showMainMenu(value));
    dispatch(push("/producer"));
  },
  handleHomePage: value => {
    dispatch(showMainMenu(value));
    dispatch(push("/"));
  },
  handleReportsPage: value => {
    dispatch(showMainMenu(value));
    dispatch(push("/reports/dailyamount"));
  },
  componentDidMount: () => {
    dispatch(subscribeOrdersRequest());
    dispatch(fetchInitialDataRequest());
  }
});

export const MainMenu = ({
  showMenu,
  handleSwitchMainMenu,
  handleHomePage,
  handleReportsPage,
  handleProducersPage
}) => {
  return (
    <div>
      <AppBar
        title={<a href="/" style={{color: 'white'}}>AF7 Merchandise POS</a>}
        iconElementLeft={
          <IconButton onClick={() => handleSwitchMainMenu(!showMenu)}>
            <NavigationMenu />
          </IconButton>
        }
        iconElementRight={<OnlineBanner />}
      />
      <Drawer
        open={showMenu}
        docked={false}
        onRequestChange={open => handleSwitchMainMenu(open)}
      >
        <MenuItem onClick={() => handleHomePage(!showMenu)}>Ventas</MenuItem>
        <MenuItem onClick={() => handleProducersPage(!showMenu)}>
          Producción
        </MenuItem>
        <MenuItem onClick={() => handleReportsPage(!showMenu)}>
          Informes
        </MenuItem>
      </Drawer>
    </div>
  );
};

const MainMenuComponent = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(MainMenu);

export default MainMenuComponent;



// WEBPACK FOOTER //
// ./src/components/container/MainMenu.js